import { LayoutType, withLayout } from 'hocs/with-layout';
import { withAuth } from 'hocs/auth/with-auth';
import { Vaults } from './vaults';

const WrapAuth = withAuth(Vaults);
const WrappedVaults = withLayout(LayoutType.WithOldNavAndFooter, WrapAuth);

export { WrappedVaults as Vaults };
